export default "/assets/images/home-wrecker2.png?e8e8435e6b7483d149572b392bff64c9";